import { jsx as h } from "react/jsx-runtime";
import { clsx as s } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import o from "./roche-highlight-box.module.scss.js";
const l = ({ color: i, children: t }) => /* @__PURE__ */ h("section", { className: s(o["highlight-box"], o[`highlight-box--${i}`]), children: t });
export {
  l as RocheUIHighlightBox
};
